import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-unfollow-confirmation-dialog',
  templateUrl: './unfollow-confirmation-dialog.component.html',
  styleUrls: ['./unfollow-confirmation-dialog.component.css']
})
export class UnfollowConfirmationDialogComponent {
  constructor(public dialogRef: MatDialogRef<UnfollowConfirmationDialogComponent>) {}

  confirmUnfollow() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
